import { Divider } from '../../../Divider'
import Text from '../../../Text'
import { ENTITY_PROFILE_TAB_UPDATES_GROUP_START_INDEX } from '../EntityProfileTabUpdates.constants'
import { EntityProfileTabUpdatesCard } from '../EntityProfileTabUpdatesCard'

import * as styles from './EntityProfileTabUpdatesListGroup.module.css'

function EntityProfileTabUpdatesListGroup({
  dateHeading,
  deletedOwnerNameKey,
  getThresholdItemProps,
  items,
  startIndex = ENTITY_PROFILE_TAB_UPDATES_GROUP_START_INDEX,
  systemOwnerNameKey,
}) {
  return (
    <div className={styles.group}>
      <div className={styles.heading}>
        <Divider className={styles.divider} />
        <Text isSecondary className={styles.title}>
          {dateHeading}
        </Text>
        <Divider className={styles.divider} />
      </div>
      <div className={styles.items}>
        {items.map((item, index) => (
          <EntityProfileTabUpdatesCard
            {...getThresholdItemProps?.(startIndex + index)}
            deletedOwnerNameKey={deletedOwnerNameKey}
            key={`${item.timestamp}-${index}`}
            systemOwnerNameKey={systemOwnerNameKey}
            value={item}
          />
        ))}
      </div>
    </div>
  )
}

export default EntityProfileTabUpdatesListGroup
